import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'verFechaArg'})
export class VerFechaArg implements PipeTransform {
  
  transform(value: string, args: string[]): any {
    if (!value) return value;
    var splitted = value.split("-"); 
    var result = "";
    if (splitted[2]){
      result = splitted[2]+"/"+splitted[1]+"/"+splitted[0];
    }
    return result;
  }
}


// WEBPACK FOOTER //
// ./src/pipes/verFechaArg.ts